<template>
  <v-flex xs6 md3>
    <router-link :to="router" class="e-unitCard--link">
      <v-card class="e-cardGramaticaComplete e-elevation--4 e-border--radius">
        <v-card-title :class="color" class="text-xs-center pa-0 justify-center align-center d-flex">
          <img src="../../assets/images/unit/checkpractica.svg" height="77" class="mt-4">
        </v-card-title>
        <v-card-text class="px-5">
          <h4 class="e-subTitle text-xs-center mt-2 pt-1" style="color: #232735;">Práctica {{ title }}</h4>
        </v-card-text>
      </v-card>
    </router-link>
  </v-flex>
</template>

<script>
export default {
  props: {
    router: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'rosa'
    }
  }
}
</script>